import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {
  selectIsDelegatedManager,
  selectRequiresActingLocation,
  useAuthenticationService
} from '../authentication-service';
import { useAdminLocationStore } from '@/services/location/useAdminLocationStore';
import { useLocationService } from '@/services/location/LocationService';

/*
 * Certain pages are very location specific.
 * For staff members with a single location, this is straightforward.
 * If they have multiple locations, we need to send them back to the homepage to choose a location before they
 * can view the page.
 */
export const RequireActingLocation: FC = () => {
  const actingLocation = useAdminLocationStore(s => s.actingLocation);
  const hasActingLocation = actingLocation !== undefined;

  const [requiresActingLocation, isDelegatedManager] = useAuthenticationService(state => [
    selectRequiresActingLocation(state),
    selectIsDelegatedManager(state)
  ]);

  const selectedLocation = useLocationService(s => s.selectedLocation);

  if (requiresActingLocation && (!isDelegatedManager || !hasActingLocation)) {
    return <Navigate to={'/'} />;
  }

  if (!selectedLocation) {
    throw Error('Location must be selected.');
  }

  return <Outlet />;
};
